module.exports = __webpack_public_path__ + "static/media/Page02_jerry_new.e6688c78.jpg";